"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copyright 2018-2023 Denis Haev (bluefox) <dogafox@gmail.com>
 *
 * MIT License
 *
 **/
// please do not delete React, as without it other projects could not be compiled: ReferenceError: React is not defined
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const i18n_1 = __importDefault(require("../i18n"));
const ObjectBrowser_1 = __importDefault(require("../Components/ObjectBrowser"));
class DialogSelectID extends react_1.Component {
    constructor(props) {
        super(props);
        this.dialogName = this.props.dialogName || 'default';
        this.dialogName = `SelectID.${this.dialogName}`;
        const filters = (window._localStorage || window.localStorage).getItem(this.dialogName) || '{}';
        try {
            this.filters = JSON.parse(filters);
        }
        catch (e) {
            this.filters = {};
        }
        if (props.filters) {
            this.filters = Object.assign(Object.assign({}, this.filters), props.filters);
        }
        let selected = this.props.selected || [];
        if (!Array.isArray(selected)) {
            selected = [selected];
        }
        selected = selected.filter(id => id);
        if (props.filterFunc) {
            if (typeof props.filterFunc === 'string') {
                try {
                    this.filterFunc = new Function('obj', props.filterFunc);
                }
                catch (e) {
                    console.error(`Cannot parse filter function: "obj => ${props.filterFunc}"`);
                    this.filterFunc = undefined;
                }
            }
            else {
                this.filterFunc = props.filterFunc;
            }
        }
        this.state = {
            selected,
            name: '',
        };
    }
    handleCancel() {
        this.props.onClose();
    }
    handleOk() {
        this.props.onOk(this.props.multiSelect ? this.state.selected : this.state.selected[0] || '', this.state.name);
        this.props.onClose();
    }
    render() {
        let title;
        if (this.state.name || this.state.selected.length) {
            if (this.state.selected.length === 1) {
                title = [
                    react_1.default.createElement("span", { key: "selected" },
                        i18n_1.default.t('ra_Selected'),
                        "\u00A0"),
                    react_1.default.createElement("span", { key: "id", style: { fontWeight: 'bold', fontStyle: 'italic' } }, (this.state.name || this.state.selected) + (this.state.name ? ` [${this.state.selected}]` : '')),
                ];
            }
            else {
                title = [
                    react_1.default.createElement("span", { key: "selected" },
                        i18n_1.default.t('ra_Selected'),
                        "\u00A0"),
                    react_1.default.createElement("span", { key: "id", style: { fontWeight: 'bold', fontStyle: 'italic' } }, i18n_1.default.t('%s items', this.state.selected.length.toString())),
                ];
            }
        }
        else {
            title = this.props.title || i18n_1.default.t('ra_Please select object ID...');
        }
        return react_1.default.createElement(material_1.Dialog, { onClose: () => { }, maxWidth: false, sx: {
                '& .MuiDialog-paper': {
                    height: '95%',
                    padding: 4,
                    width: '100%',
                    maxWidth: '100%',
                    maxHeight: 'calc(100% - 16px)',
                }
            }, fullWidth: true, open: !0, "aria-labelledby": "ar_dialog_selectid_title" },
            react_1.default.createElement(material_1.DialogTitle, { id: "ar_dialog_selectid_title", style: {
                    whiteSpace: 'nowrap',
                    width: 'calc(100% - 72px)',
                    overflow: 'hidden',
                    display: 'inline-block',
                    textOverflow: 'ellipsis',
                } }, title),
            react_1.default.createElement(material_1.DialogContent, { style: {
                    height: '100%',
                    overflow: 'hidden',
                    padding: '8px 4px',
                } },
                react_1.default.createElement(ObjectBrowser_1.default, { foldersFirst: this.props.foldersFirst, imagePrefix: this.props.imagePrefix || this.props.prefix, defaultFilters: this.filters, dialogName: this.dialogName, showExpertButton: this.props.showExpertButton !== undefined ? this.props.showExpertButton : true, expertMode: this.props.expertMode, 
                    // style={{ width: '100%', height: '100%' }}
                    columns: this.props.columns || ['name', 'type', 'role', 'room', 'func', 'val'], types: this.props.types ? (Array.isArray(this.props.types) ? this.props.types : [this.props.types]) : ['state'], root: this.props.root, t: i18n_1.default.t, lang: this.props.lang || i18n_1.default.getLanguage(), socket: this.props.socket, selected: this.state.selected, multiSelect: this.props.multiSelect, notEditable: this.props.notEditable === undefined ? true : this.props.notEditable, 
                    // name={this.state.name}
                    themeName: this.props.themeName, themeType: this.props.themeType, customFilter: this.props.customFilter, onFilterChanged: filterConfig => {
                        this.filters = filterConfig;
                        (window._localStorage || window.localStorage).setItem(this.dialogName, JSON.stringify(filterConfig));
                    }, onSelect: (selected, name, isDouble) => {
                        if (JSON.stringify(selected) !== JSON.stringify(this.state.selected)) {
                            this.setState({ selected, name }, () => isDouble && this.handleOk());
                        }
                        else if (isDouble) {
                            this.handleOk();
                        }
                    }, filterFunc: this.filterFunc, title: "", classes: {} })),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement(material_1.Button, { id: `ar_dialog_selectid_ok_${this.props.dialogName || ''}`, variant: "contained", onClick: () => this.handleOk(), startIcon: react_1.default.createElement(icons_material_1.Check, null), disabled: !this.state.selected.length, color: "primary" }, this.props.ok || i18n_1.default.t('ra_Ok')),
                react_1.default.createElement(material_1.Button, { id: `ar_dialog_selectid_cancel_${this.props.dialogName || ''}`, 
                    // @ts-expect-error
                    color: "grey", variant: "contained", onClick: () => this.handleCancel(), startIcon: react_1.default.createElement(icons_material_1.Cancel, null) }, this.props.cancel || i18n_1.default.t('ra_Cancel'))));
    }
}
exports.default = DialogSelectID;
